module.exports = __webpack_public_path__ + "static/media/subscription-banner.9e3efe6d.jpg";